<div>
  <div class="trans-bg p-20 border-radius10 d-inline-block m-b-20" *ngIf="!gettingProducts">
    <h4 class="t-14 bold">Redeem {{ productName }}</h4>
    <span class="t-14">{{ message }}</span>
    <br />
    <button class="btn btn-primary m-t-10" (click)="redeem()">{{ (redeeming ? "general.redeeming_dots" : "general.redeem") | translate }}</button>
  </div>
</div>
